import React from 'react';
const IconActionEditCircleFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM15 7L17 9L15.59 10.41L13.59 8.41L15 7ZM7.5 14.5L12.53 9.47L14.53 11.47L9.5 16.5H7.5V14.5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionEditCircleFill;